/**
 * @class
 * @abstract
 * @param {SocialConnectConnectorAbstract} _this
 */
var SocialConnectConnectorAbstract = function(_this) {

    this._settings = {};
    this._initialized = false;

    /**
     * @abstract
     * @returns {string}
     */
    this.getType = function() {
        throw new Error('Function not implemented');
    };

    /**
     * @abstract
     * @returns {JQueryDeferred}
     */
    this._clientConnect = function() {
        throw new Error('Function not implemented');
    };

    this.isInitialized = function() {
        return this._initialized;
    };

    this.initSettings = function(settings) {
        this._settings = settings;
        DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_INIT_SETTINGS_AFTER + '_' + this.getType());
    };

    /**
     * @returns {JQueryDeferred}
     */
    this.connect = function() {
        return $j.Deferred(function() {
            let deferred = this;

            DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_BEFORE + '_' + _this.getType()).done(function() {
                _this._clientConnect().done(function(data) {
                    deferred.resolve(data);
                }).fail(function(data) {
                    deferred.reject(data);
                });
            });
        });
    };

    this.getSettings = function() {
        return this._settings;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onInitAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(SocialConnectConnectorAbstract.EVENT_INIT_AFTER + '_' + this.getType(), handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onInitSettingsAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(SocialConnectConnectorAbstract.EVENT_INIT_SETTINGS_AFTER + '_' + this.getType(), handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onClientConnectBefore = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_BEFORE + '_' + this.getType(), handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onServerConnectBefore = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_BEFORE + '_' + this.getType(), handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onClientConnectSuccessAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_SUCCESS_AFTER + '_' + this.getType(), handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onServerConnectSuccessAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_SUCCESS_AFTER + '_' + this.getType(), handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onClientConnectFailAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_FAIL_AFTER + '_' + this.getType(), handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=DeferredEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onServerConnectFailAfter = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_FAIL_AFTER + '_' + this.getType(), handler, priority, ignoreCancel, this);
        return this;
    };

    /**
     * @returns {JQueryDeferred}
     */
    this._clientConnectSuccessCallback = function(data) {
        return $j.Deferred(function() {
            let deferred = this;

            DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_SUCCESS_AFTER + '_' + _this.getType(), data);

            data = {type: _this.getType(), data: data, url: _this.getSettings()['url']};
            DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_BEFORE + '_' + _this.getType(), data).done(function() {
                $j.post(data.url, {
                    type: data.type,
                    data: data.data
                }).done(function(data) {
                    DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_SUCCESS_AFTER + '_' + _this.getType(), data);
                    deferred.resolve(data);
                }).fail(function(data) {
                    DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_FAIL_AFTER + '_' + _this.getType(), data);
                    deferred.reject(data);
                });
            });
        });
    };

    this._clientConnectFailCallback = function(error) {
        DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_FAIL_AFTER + '_' + this.getType(), error);
    };
};

SocialConnectConnectorAbstract.EVENT_INIT_AFTER                   = 'socialconnect_connector_init_after';
SocialConnectConnectorAbstract.EVENT_INIT_SETTINGS_AFTER          = 'socialconnect_connector_init_settings_after';
SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_BEFORE        = 'socialconnect_connector_client_connect_before';
SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_BEFORE        = 'socialconnect_connector_server_connect_before';
SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_SUCCESS_AFTER = 'socialconnect_connector_client_connect_success_after';
SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_SUCCESS_AFTER = 'socialconnect_connector_server_connect_success_after';
SocialConnectConnectorAbstract.EVENT_CLIENT_CONNECT_FAIL_AFTER    = 'socialconnect_connector_client_connect_fail_after';
SocialConnectConnectorAbstract.EVENT_SERVER_CONNECT_FAIL_AFTER    = 'socialconnect_connector_server_connect_fail_after';

export default SocialConnectConnectorAbstract;
